<template>
  <div class="webdatalist">
    <f7-list media-list accordion class="searchbar-found" id="bank-list">
      <f7-list-item
        accordion-item accordion-item-opened
        v-for="account in filteredBankAccounts"
        media="<i class='icon list-icon icon-credit_card'></i>"
        class="bankAccountList accordion-item-expanded boxRequest"
        :key="account.id"
        :title="account.name"
        :subtitle="formattedBankData(account.iban, account.zoneCode)">

        <f7-accordion-content class="greyfont">
          <div v-if="account.balances !== undefined && account.balances.length > 0" class="data-table card statementTable">
            <table class="showLargeScreenOnly">
              <thead>
                <tr>
                  <th width='15%'>Date</th>
                  <th width='20%'>End to End Id</th>
                  <th width='20%'>Reference</th>
                  <th width='15%'>Second Party name</th>
                  <th width='15%'>Value</th>
                  <th width='15%'>Remaining Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr class="mainLineStatementTable">
                  <td>{{account.opbd_date | formatDate}}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{account.initialAmount | formatCommaNumber}} {{ getCurrency(account.zoneCode) }}</td>
                </tr>
                <tr v-for="balance in account.balances">
                  <td>{{balance.execution_date | formatDate}}</td>
                  <td>{{balance.end_to_end_id}}</td>
                  <td>{{balance.reference}}</td>
                  <td>{{balance.creditor_debtor_name}}</td>
                  <td>
                    <span v-if="balance.credit_debit_indicator=='DBIT'">
                      -
                    </span>
                    <span v-else>
                      +
                    </span> {{balance.amount | formatCommaNumber}} {{ getCurrency(account.zoneCode) }}
                  </td>
                  <td class="">{{balance.printed_opbd_amount | formatCommaNumber}} {{ getCurrency(account.zoneCode) }}</td>
                </tr>
                  <tr class="mainLineStatementTable">
                    <td>{{account.balances[account.balances.length - 1].execution_date | formatDate}}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{{account.balances[account.balances.length - 1].printed_opbd_amount | formatCommaNumber}} {{ getCurrency(account.zoneCode) }}</td>
                  </tr>
              </tbody>
            </table>
            <table class="showSmallScreenOnly statementSmallScreen">
              <tbody>
                <tr>
                  <td><span class="smallScreenStatementDescription pull-left">Date : </span><span class="mainLineStatementTable pull-right">{{account.opbd_date | formatDateTime}}</span> <br />
                    <span class="smallScreenStatementDescription pull-left">Initial Amount : </span><span class="mainLineStatementTable pull-right">{{account.initialAmount | formatCommaNumber}} {{ getCurrency(account.zoneCode) }}</span></td>
                </tr>
                <tr v-for="balance in account.balances">
                  <td>
                    <span class="smallScreenStatementDescription pull-left">Date : </span>
                    <span class="pull-right">{{balance.execution_date | formatDate}}</span>
                    <br />
                    <span class="smallScreenStatementDescription pull-left">End To End Id : </span>
                    <span class="pull-right">{{balance.end_to_end_id}}</span>
                    <br />
                    <span class="smallScreenStatementDescription pull-left">Reference : </span>
                    <span class="pull-right">{{balance.reference}}</span>
                    <br />
                    <span class="smallScreenStatementDescription pull-left">Second Party Name : </span>
                    <span class="pull-right">{{balance.creditor_debtor_name}}</span>
                    <br />
                    <span class="smallScreenStatementDescription pull-left">Value : </span>
                    <span class="mainLineStatementTable pull-right">
                      <span v-if="balance.credit_debit_indicator=='DBIT'">-</span>
                      <span v-else>+</span>
                      {{balance.amount | formatCommaNumber}} {{ getCurrency(account.zoneCode) }}
                    </span>
                    <br />
                    <span class="smallScreenStatementDescription pull-left">Remaining Amount : </span>
                    <span class="pull-right">{{balance.printed_opbd_amount | formatCommaNumber}} {{ getCurrency(account.zoneCode) }}</span>
                  </td>
                </tr>
                  <tr>
                    <td>
                      <span class="smallScreenStatementDescription pull-left">Date : </span>
                      <span class="mainLineStatementTable pull-right">{{account.balances[account.balances.length - 1].execution_date | formatDate}}</span>
                      <br />
                      <span class="smallScreenStatementDescription pull-left">Remaining Amount : </span>
                      <span class="mainLineStatementTable pull-right">{{account.balances[account.balances.length - 1].printed_opbd_amount | formatCommaNumber}} {{ getCurrency(account.zoneCode) }}</span>
                    </td>
                  </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="text-center">
            <div class="emptyStatement"><i style="margin-top: 2%;margin-bottom: 2%;"> No statement is currently available for this bank account. </i></div>
          </div>
        </f7-accordion-content>
      </f7-list-item>
    </f7-list>
</div>
</template>

<script>
import {extractForeignIban} from '@/helpers/format'

export default {
  name: 'BankAccountList',
  props: ['bankAccounts', 'filterBy'],
  created () {
    this.bankAccountSelected = this.$engine.bankAccounts.getIbanStatment()
  },
  computed: {
    filteredBankAccounts () {
      let that = this
      let result = []
      if (this.filterBy) {
        for (var m in that.bankAccounts) {
          if (that.bankAccounts[m].name.toLowerCase().includes(this.filterBy.toLowerCase())) {
            result.push(that.bankAccounts[m])
          }
        }
        if (result.length !== 0) {
          that.Dom7('.page-on-center .searchbar-not-found').css('display', 'none')
          that.Dom7('.page-on-center #bank-list').css('display', 'block')
        }
        return result
      }

      /* TLV 08/01/2020
      * On sélectionne ensuite seulement les comptes liés à l'IBAN actuel, s'il n'y en a qu'un seul de sélectionné
      */
      if (this.bankAccountSelected !== '') {
        for (var p in that.bankAccounts) {
          if (that.bankAccounts[p].iban.toLowerCase() === this.bankAccountSelected.toLowerCase()) {
            result.push(that.bankAccounts[p])
          }
        }
        return result
      }
      return this.bankAccounts
    }
  },
  methods: {
    /** @author TLV 19/05/2020
    * @fn formattedBankData
    * @brief prépare les données bancaires (sort code, account number etc) à afficher sur les statements
    */
    formattedBankData (iban, zone) {
      zone = this.$i18n.t('zoneCodes.' + zone)
      let bankDataToString = ''
      let extractedDataFromIban = extractForeignIban(iban, zone)
      for (let accountData in extractedDataFromIban) {
        bankDataToString += this.$i18n.t(extractedDataFromIban[accountData].labelId) + ' : ' +
                            extractedDataFromIban[accountData].hiddenValue + ' '
      }
      return bankDataToString
    },
    getCurrency (zoneCode) {
      return this.$engine.bankAccounts.getCurrency(zoneCode)
    }
  }
}
</script>

<style>
.bankAccountList>.item-link>.item-content>.item-inner>.item-title-row>.item-title {
  color: #12bcf1 !important;
}
</style>



// WEBPACK FOOTER //
// CMBankAccountsListStatement.vue?91aa3a24